module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-cocojs43b3f450e59124470fff8a692f0ec5c9.svg";